import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AutoCenter, DotLoading, Button } from "antd-mobile";
import api from "../../api";
import "./style.less";

const Alipay = () => {
  const navigate = useNavigate();

  const [authBotton, setAuthBotton] = useState(true);

  // 获取全局alipay对象
  const ap = window.ap;

  const alipayLogin = (appId) => {
    ap.getAuthCode(
      {
        appId,
        scopes: ['auth_base'],
      },
      function (res) {
        const { authCode } = res;

        // 支付宝AuthCode换取Token等
        api.alipayAuthRedirect({ authCode }).then((res) => {
          if (res.data.code === 0) {
            if (res.data.data.userId === 0) {
              navigate("/login/alipay/bind/mobile")
            } else {
              navigate("/home")
            }
          } else {
            setAuthBotton(true);
          }
        })
      }
    );
  }

  const handleAlipayAuth = () => {
    api.alipayAppId().then((res) => {
      if (res.data.code === 0) {
        setAuthBotton(false);

        const appId = res.data.data;
        alipayLogin(appId);
      }
    })
  }

  return (
    <div className="wechat-login-wrapper">
      {
        authBotton ?
          <AutoCenter>
            <div className="wechat-login-hint">
              <span>请登陆后使用充电服务，谢谢!</span>
            </div>
            <Button block color="success" onClick={() => handleAlipayAuth()}>登 陆</Button>
          </AutoCenter>
          :
          <AutoCenter>
            <div>
              <span>登陆中</span>
              <DotLoading color='currentColor' />
            </div>
          </AutoCenter>
      }
    </div>
  )
}

export default Alipay;